import React from 'react';
import createArtistListRoute from '../utils/artist-list-page';
import ArtistListPage from '../components/common/ArtistListPage';

import {
  selectSoloistsIsLoading,
  selectNextSoloistsCursor,
  selectPrevSoloistsCursor,
  selectSoloists,
} from '../selectors/soloists';
import * as soloistActions from '../actions/soloist';

const route = createArtistListRoute({
  artistType: 'soloists',
  selectItems: selectSoloists,
  selectIsLoading: selectSoloistsIsLoading,
  selectNextCursor: selectNextSoloistsCursor,
  selectPrevCursor: selectPrevSoloistsCursor,
  loadAction: soloistActions.loadSoloists,
});

const Soloists = ({ ...props }) => {
  return <ArtistListPage {...props} />;
};

Soloists.onDataFetch = route.onDataFetch;

export default route(Soloists);
